import { setScriptKey } from "@progress/kendo-licensing";
import React from "react";
import ReactDOM from "react-dom";
import { clarity } from "react-microsoft-clarity";
import { Provider } from "react-redux";
import App from "./App";
import { setupAxiosAuth } from "./app/axiosAuth";
import store from "./app/store";
import SignalRComponent from "./app/WebSocket";
import { envVariables as eV } from "./components/Common/Store/CommonSignals";
import { getEnvVariables } from "./components/Common/Store/EnvSlice";
import "./index.css";

async function initApp() {
  setupAxiosAuth();

  await store.dispatch(getEnvVariables());
  const envVariables = store.getState().env.EnvVariables;
  eV.value = envVariables;

  setScriptKey(envVariables.REACT_APP_KENDO_UI_LICENSE_KEY);
  clarity.init(envVariables.REACT_APP_CLARITY_ID);

  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <SignalRComponent />
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

initApp();
